/* sb-dc-cartprops.js — make design-center line items look like a normal
   StickersBanners order in Order Desk.

   A regular (non design-center) order shows:
     SKU / WIDTH / HEIGHT        — variant options, not line-item properties
     SPECIAL INSTRUCTIONS        — ONLY when the customer actually typed one
     FINISHING OPTIONS:    Hem Only
     UPLOADED FILE:        https://…/Jacksally_….jpg

   The design center was sending eleven properties instead, including the
   whole internal audit trail (_DESIGN_ID, _APP, _PRINT_DPI, _PRINT_PX,
   _PRINT_SHA256, _PRODUCT_HANDLE, _SIZE_IN, _DESIGN_JSON…). Order Desk
   shows underscore-prefixed properties too, so the only way to hide them
   is not to send them.

   Requested 2026-08-27: match the normal order format, drop the rest.
   SPECIAL INSTRUCTIONS is a customer-written field — never synthesised
   here. The design center has no such input today, so it simply does not
   appear; if one is added later and lands in the properties, it passes
   through untouched.

   The one property added back on purpose is CUSTOMER ACKNOWLEDGED. When a
   customer ticks past a blocking preflight issue (see sb-dc-override.js),
   production has to see that on the order — otherwise a knowingly-accepted
   low-resolution job looks like our mistake at press.

   Done by intercepting /cart/add.js rather than editing the 314KB augment
   bundle, so nothing has to be re-uploaded by hand. Add-on line items
   (stands, red carpets) are left untouched — only items carrying a print
   file are rewritten. */
(function () {
  'use strict';

  function pick(props, names) {
    for (var i = 0; i < names.length; i++) {
      var v = props[names[i]];
      if (v != null && String(v).trim() !== '') return v;
    }
    return null;
  }

  function acknowledged() {
    try {
      if (!window.__dcOverrideOn || !window.__dcOverrideOn()) return null;
      var list = (window.__dcOverrideIssues && window.__dcOverrideIssues()) || [];
      return list.length
        ? 'Customer accepted print as-is — ' + list.join('; ')
        : 'Customer accepted print as-is';
    } catch (e) { return null; }
  }

  function fix(props) {
    if (!props || typeof props !== 'object') return props;
    // Only design-center items carry a print file; leave add-ons alone.
    var printUrl = pick(props, ['Print File', 'PRINT FILE']);
    if (!printUrl) return props;

    var out = {};

    // Customer-written only. Passed through if it exists, never invented.
    var si = pick(props, ['SPECIAL INSTRUCTIONS', 'Special Instructions', 'Special instructions']);
    if (si) out['SPECIAL INSTRUCTIONS'] = si;

    // Kept on purpose: on stickers and decals this is the customer's vinyl
    // choice, and getting it wrong means a reprint. Banners never set it.
    var mat = pick(props, ['Material', 'MATERIAL']);
    if (mat) out['MATERIAL'] = mat;

    var fin = pick(props, ['FINISHING OPTIONS', 'Finishing']);
    if (fin) out['FINISHING OPTIONS'] = fin;

    var ack = acknowledged();
    if (ack) out['CUSTOMER ACKNOWLEDGED'] = ack;

    out['UPLOADED FILE'] = printUrl;
    var back = pick(props, ['Print File (Back)', 'PRINT FILE (BACK)']);
    if (back) out['UPLOADED FILE (BACK)'] = back;

    return out;
  }

  function isCartAdd(url) {
    try { return /\/cart\/add(\.js)?(\?|$)/.test(String(url || '')); } catch (e) { return false; }
  }

  var orig = window.fetch;
  if (typeof orig !== 'function' || orig.__dcPropsWrapped) return;

  var wrapped = function (input, init) {
    try {
      var url = (typeof input === 'string') ? input : (input && input.url) || '';
      var body = init && init.body;
      if (isCartAdd(url) && typeof body === 'string' && body.indexOf('properties') >= 0) {
        var data = JSON.parse(body);
        var touched = false;
        if (data && Array.isArray(data.items)) {
          data.items.forEach(function (it) {
            if (it && it.properties) { it.properties = fix(it.properties); touched = true; }
          });
        } else if (data && data.properties) {
          data.properties = fix(data.properties); touched = true;
        }
        if (touched) init = Object.assign({}, init, { body: JSON.stringify(data) });
      }
    } catch (e) {
      // Never let this block an order — fall through with the original body.
      try { console.warn('[design-center] cart property tidy skipped:', e); } catch (e2) {}
    }
    return orig.apply(this, [input, init]);
  };
  wrapped.__dcPropsWrapped = true;
  window.fetch = wrapped;
})();
